module.exports = __webpack_public_path__ + "img/icon_super_down@3x.3ad24c2b.png";